import React from 'react';

export const FilterContext = React.createContext({
    inputFilter: '',
    setInputFilter: (filter) => { }
});

export const ThemeProvider = FilterContext.Provider;
export const ThemeConsumer = FilterContext.Consumer;